import React, { useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Row, Col } from 'react-bootstrap'
import { TextField } from '@material-ui/core'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { FORM_PRODUCTIVIDAD_VOLCADORAS } from '../../../../config/forms'
import { renderSelectField, renderTextAreaField } from '../../../Forms/fieldRenderers'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'

function CamposDemoraEnVolcadora (props) {
  const { motivosDemora, volcadoras, fechaDesde = null, fechaHasta = null, hInicio = null, hFin = null, change: formChange, rolAutorizado = false, observaciones = null } = props
  const [selectedMotivo, setSelectedMotivo] = useState(props.motivosDemora)
  const [selectedVolcadora, setSelectedVolcadora] = useState(props.volcadoraCamiones)
  const [horaInicio, setHoraInicio] = useState(hInicio || moment(new Date()).format('HH:mm'))
  const [horaFin, setHoraFin] = useState(hFin || moment(new Date()).format('HH:mm'))

  const renderMotivos = () => {
    const motivosHabilitados = motivosDemora.filter((m) => m.habilitado)
    const options = motivosHabilitados.map((m) => {
      return (
        <option
          value={m.nombreCorto.trim()}
          key={m.nombreCorto}
        >
          {m.nombre}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  const renderVolcadoras = () => {
    const options = volcadoras.map((v) => {
      return (
        <option
          value={v.nombreCorto.trim()}
          key={v.nombreCorto}
        >
          {v.nombre}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaInicioDemora', moment(fechaD).format('DD/MM/YYYY'))
    formChange('fechaFinDemora', moment(fechaH).format('DD/MM/YYYY'))
  }

  const changeHoraInicio = (e) => {
    setHoraInicio(e.target.value)
    formChange('horaInicio', e.target.value)
  }

  const changeHoraFin = (e) => {
    setHoraFin(e.target.value)
    formChange('horaFin', e.target.value)
  }

  return (
    <Row>
      <Col md={6} style={{ marginTop: '12px' }}>
        <DatePicker
          selectRange
          fechaDesde={fechaDesde || null}
          fechaHasta={fechaHasta || null}
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Selecciones las fechas'
          value='fechas'
        />
      </Col>

      <Col md={3} style={{ display: 'flex', alignItems: 'flex-end' }}>
        <form noValidate style={{ width: '95%' }}>
          <TextField
            style={{ margin: '0 auto 2% auto', width: '100%' }}
            id='time'
            name='horaInicio'
            type='time'
            defaultValue={horaInicio || moment(new Date()).format('HH:mm')}
            label='Hora inicio *'
            onChange={(h) => { changeHoraInicio(h) }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              step: 300 // 5 min
            }}
          />
        </form>
      </Col>

      <Col md={3} style={{ display: 'flex', alignItems: 'flex-end' }}>
        <form noValidate style={{ width: '95%' }}>
          <TextField
            style={{ margin: '0 auto 2% auto', width: '100%' }}
            id='time'
            name='horaFin'
            type='time'
            defaultValue={horaFin || moment(new Date()).format('HH:mm')}
            label='Hora fin *'
            onChange={(h) => { changeHoraFin(h) }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              step: 300 // 5 min
            }}
          />
        </form>
      </Col>

      { motivosDemora && motivosDemora.length > 0 && <Col md={6} style={{ margin: '6% 0 0 0' }}>
        <Field
          onChange={(m) => setSelectedMotivo(m)}
          name='motivoDemora'
          label='Motivo de demora *'
          autoFocus={false}
          component={renderSelectField}
          value={selectedMotivo}
        >
          {renderMotivos()}
        </Field>
      </Col>
      }

      { volcadoras && volcadoras.length > 0 && <Col md={6} style={{ margin: '6% 0 0 0' }}>
        <Field
          onChange={(v) => setSelectedVolcadora(v)}
          name='volcadoraCamiones'
          label='Volcadora *'
          autoFocus={false}
          component={renderSelectField}
          value={selectedVolcadora}
        >
          {renderVolcadoras()}
        </Field>
      </Col>
      }

      {rolAutorizado && <Col md={12}>
        <Field
          name='observacionesDemora'
          component={renderTextAreaField}
          autoFocus={false}
          label='Observaciones'
          style={{
            width: '100%',
            borderColor: '#d2d2d2',
            borderRadius: '4px',
            minHeight: '80px'
          }}
          value={observaciones || null}
        />
      </Col> }

      <Col md={12} style={{ textAlign: 'rigth', marginTop: '8px' }}>
        <p>(*) Campo requerido obligatorio</p>
      </Col>

    </Row>
  )
}

const selector = formValueSelector(FORM_PRODUCTIVIDAD_VOLCADORAS)

const mapStateToProps = (state) => ({
  fechaInicioDemora: selector(state, 'fechaInicioDemora'),
  fechaFinDemora: selector(state, 'fechaFinDemora'),
  horaInicio: selector(state, 'horaInicio'),
  horaFin: selector(state, 'horaFin'),
  volcadoraCamiones: selector(state, 'volcadoraCamiones'),
  motivosDemora: state.volcadora.motivosDemoraVolcadora,
  volcadoras: state.volcadora.volcadorasCamiones,
  roles: state.auth.roles
})

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_PRODUCTIVIDAD_VOLCADORAS
})

export default withRedux(withReduxForm(CamposDemoraEnVolcadora))
